module.exports = __webpack_public_path__ + "img/login-bg.8239dab9.jpg";